<template>
	<AutoComplete
		v-model="params.data.peopleInvolved"
		:suggestions="filteredPeople"
		field="label"
		:multiple="true"
		@complete="searchAuthors($event)"
		@item-select="selectChanges($event)"
		@item-unselect="unselectChanges($event)"
	/>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
export default {
	name: "tableAutoComplete",
	components: {
		AutoComplete
	},
	data() {
		return {
			filteredPeople: null
		};
	},
	methods: {
		selectChanges() {
			if (
				this.params.data.tasks == "Design systematic search strategy" ||
				this.params.data.tasks == "Run systematic search strings" ||
				this.params.data.tasks == "Deduplicate results"
			) {
				//console.log("this.params.data.peopleInvolved:",this.params.data.peopleInvolved);
				this.params.api.getRenderedNodes().forEach(node => {
					if (
						node.data.tasks == "Design systematic search strategy" ||
						node.data.tasks == "Run systematic search strings" ||
						node.data.tasks == "Deduplicate results"
					) {
						node.data.peopleInvolved = this.params.data.peopleInvolved;
					}
				});
				this.$tera.project.searchStrategyAuthors = this.params.data.peopleInvolved;
			}
			//console.log("selectChanges", this.params);
			//Manually save event changes to terafy
			this.$tera.project.planTable.rows[this.params.rowIndex][
				this.params.colDef.field
			] = this.params.data[this.params.colDef.field];
		},
		unselectChanges() {
			if (
				this.params.data.tasks == "Design systematic search strategy" ||
				this.params.data.tasks == "Run systematic search strings" ||
				this.params.data.tasks == "Deduplicate results"
			) {
				//console.log("this.params.data.peopleInvolved:",this.params.data.peopleInvolved);
				this.params.api.getRenderedNodes().forEach(node => {
					if (
						node.data.tasks == "Design systematic search strategy" ||
						node.data.tasks == "Run systematic search strings" ||
						node.data.tasks == "Deduplicate results"
					) {
						node.data.peopleInvolved = this.params.data.peopleInvolved;
					}
				});
				this.$tera.project.searchStrategyAuthors = this.params.data.peopleInvolved;
			}
			//console.log("unselectChanges", this.params);
			//Manually save event changes to terafy
			this.$tera.project.planTable.rows[this.params.rowIndex][
				this.params.colDef.field
			] = this.params.data[this.params.colDef.field];
		},
		searchAuthors(event) {
			setTimeout(() => {
				if (!event.query.trim().length) {
					this.filteredPeople = [...this.params.titlePageAuthors];
				} else {
					this.filteredPeople = this.params.titlePageAuthors.filter(people => {
						return people.label
							.toLowerCase()
							.startsWith(event.query.toLowerCase());
					});
				}
				//console.log("filteredPerson:", this.filteredPeople);
			}, 250);
		}
	}
};
</script>
<style>
.p-autocomplete {
	display: grid;
	line-height: normal; /** setting input element not too large */
	width: 100%;
	height: 70%;
}

.p-autocomplete-multiple-container {
	background-color: transparent !important;
	display: inline !important;
	border: none;
	overflow: auto;
      min-height: 100px !important;
}
.p-autocomplete-token {
	display: block;
}
.p-autocomplete-panel {
	line-height: normal;
	height: auto !important;
	max-height: 250px !important;
}
</style>
